<div class="main-content-container">
  <div class="main-container-body">
    <!-- <div class="patient-card">
    <app-resource-banner [bannerJson]="bannerJson" (patientResult)="getPatientData($event);">
    </app-resource-banner>
  </div> -->
  <div class="page-title-container d-flex">
    @if (!utilService.isMobile()) {
      <div class="page-title flex-grow-1 ng-star-inserted">
        <div class="mb-0 ng-star-inserted">
          <div class="d-flex align-items-center">
            <div class="pl-2 pr-2 ng-star-inserted">
              <a class="d-inline-flex" href="javascript:void(0)" (click)="back()">
                <img src="assets/images/grid-back.png">
              </a>
            </div>
            <div>Duty Roster</div>
          </div>
        </div>
      </div>
    }
  </div>
  @if (action != 'view') {
    <div class="main-content-container app-ui-engine-container layout_simple main-box-shadow"
      >
      @if (resourceDef != undefined) {
        <div class="form-container">
          <dhs-form [action]="'ADD'" [config]="config" [fieldGroup]="resourceDef.form" [decorator]="self" [data]="defaultData"
            (questionValueChanged)="questionValueChanged($event)">
          </dhs-form>
        </div>
      }
      <!-- <div *ngIf="dateForm">
      <div class="page-title ml-3">Dates</div>
      <dhs-form [action]="'ADD'" [config]="config" [fieldGroup]="dateForm"
        (questionValueChanged)="questionValueChangedForDate($event)">
      </dhs-form>
    </div> -->
    <div [hidden]="!isLoaded">
      <dhs-editable-grid #editGrid [resource]="editGridResource" [config]="gridConfig"  (listen_changes)="listen_changes($event)"
        style="min-width: 100%;">
      </dhs-editable-grid>
    </div>
    <div [hidden]="!isLoaded" class="row form-primary-actions sticky-add-btn mt-3">
      <div class="col-12 text-center" id="showButtons">
        <button class="aside-fixed-button primary-btn submitButton" (click)="saveData('final')">Final<i
        class="fa fa-check ml-2" aria-hidden="true"></i></button>
        @if (action == 'DUTY_' || action == 'DUTY_ROSTER_CREATION') {
          <button
            class="aside-fixed-button primary-btn submitButton" (click)="saveData('draft')">Draft<i
          class="fa fa-save ml-2" aria-hidden="true"></i></button>
        }
      </div>
    </div>
  </div>
}
@if (action == 'view') {
  <div class="main-content-container app-ui-engine-container layout_simple main-box-shadow"
    >
    @if (dutyRoster.view) {
      <div class="dataContainer">
        <!-- <dhs-form-view [data]="dutyRoster.view" [fieldGroup]="resourceDef.form" [buttonConf]=false>
      </dhs-form-view> -->
      <div class="kx-control col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
        <label class=" control-label col-12 pl-0">
          <span class="font-weight-bold">Department</span>
        </label>
        <div class="te col-12 pl-0">{{dutyRoster.view.department_name}}</div>
      </div>
      <div class="kx-control col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
        <label class=" control-label col-12 pl-0">
          <span class="font-weight-bold">Ward Type</span>
        </label>
        <div class="text-break col-12 pl-0">{{dutyRoster.view.wardType_name}}</div>
      </div>
      <div class="kx-control col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
        <label class=" control-label col-12 pl-0">
          <span class="font-weight-bold">Ward</span>
        </label>
        <div class="text-break col-12 pl-0">{{dutyRoster.view.ward_name}}</div>
      </div>
      <div class="kx-control col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
        <label class=" control-label col-12 pl-0">
          <span class="font-weight-bold">Month</span>
        </label>
        <div class="text-break col-12 pl-0">{{dutyRoster.view.month_code}}</div>
      </div>
      <div class="kx-control col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
        <label class=" control-label col-12 pl-0">
          <span class="font-weight-bold">Year</span>
        </label>
        <div class="text-break col-12 pl-0">{{dutyRoster.view.year}}</div>
      </div>
      <div class="kx-control col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
        <label class=" control-label col-12 pl-0">
          <span class="font-weight-bold">Store</span>
        </label>
        @for (store of dutyRoster.view.store_id; track store) {
          <span>{{store.text}},</span>
        }
      </div>
    </div>
  }
  <!-- <dhs-data-grid [fields]="resourceDef.list.fields" [data]="GridData" [config]="dataConfig"
  (bulkActionClicked)="onBulkActionClicked($event)">
</dhs-data-grid> -->
<div class="table-action-container">
  <div class="d-flex align-items-center">
    <div>
      <label class="control-label col-12 pl-0">
        <span class="font-weight-bold">Start</span>
      </label>
      <input type="text" ngxDaterangepickerMd
        class="form-control input-element-main-search datepicker-search"
        [placeholder]="'field.label.choose_date' | translate | async" showCancel="true"
        [singleDatePicker]="true" [showClearButton]="true" [locale]="'DD/MM/YYYY'"
        (change)="startValue($event)" />
    </div>
    <div class="ml-2">
      <label class="control-label col-12 pl-0">
        <span class="font-weight-bold">End</span>
      </label>
      <input type="text" ngxDaterangepickerMd
        class="form-control input-element-main-search datepicker-search"
        [placeholder]="'field.label.choose_date' | translate | async" showCancel="true"
        [singleDatePicker]="true" [showClearButton]="true" [locale]="'DD/MM/YYYY'"
        (change)="endValue($event)" />
    </div>
    <div class="ml-2 mt-3">
      <button class="aside-fixed-button primary-btn submitButton" (click)="applyFilter()">Apply<i
      class="fa fa-check ml-2" aria-hidden="true"></i></button>
    </div>
    <div class="ml-auto table-quick-actions">
      <button type="button" class="btn-with-icon-label" (click)="onBulkActionClicked()">
        <i aria-hidden="true" class="fa fa-print"></i>
        <span>Print</span>
      </button>
    </div>
  </div>
</div>
<div class="table-responsive max-height-unset" style="max-height: 40vh;overflow: auto;">
  @if (!utilService.isMobile()) {
    <div>
      <table class="table mb-0">
        <thead>
          <tr>
            @for (field of headingArray; track field) {
              <th scope="col" style="min-width: 5.2em;">
              {{field.heading| translate | async}}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (value of dutyRoster.resource; track value; let i = $index) {
            <tr>
              @for (field of headingArray; track field) {
                @if (field.type == undefined) {
                  <td style="min-width: 8.5em;">{{value[field.name]}}
                  </td>
                }
                @if (field.type == 'composite') {
                  <td scope="row"
                    [ngClass]="getClass(value, field.class_conditions)">
                  {{ (value | mapvalue: field)?(value | mapvalue: field):'-'}} </td>
                }
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
</div>
}
</div>
</div>